import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { EventEmitter } from 'events';

@Component({
  selector: 'apm-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {

  @Input() data = [];
  @Output() setDataInto: EventEmitter<any> = new EventEmitter<any>();
  @Input() setFilterData=[]; 
  filterDialog: boolean = false;
  searchElement: string;
  searchElementColumn: any;
  searchColumnValue: any = [];
  searchElementValue: any;
  searchFilter: any = [];
  searchColumn: any = [];

  constructor() { }

  ngOnInit() {
    
    if(this.setFilterData.length>0){
      this.searchFilter=this.setFilterData;
    }
  }

  ngOnChanges() {

    this.searchColumn = this.data;
    this.searchElementColumn = this.searchColumn[0].value;
    this.searchElement = this.searchColumn[0].value.type;
    
    if (this.searchColumn[0].value.type == 'dropdown') {
      this.searchColumnValue = this.searchColumn[0].value.value;
    }

  }

  onSelectFilterColumn(event) {
    let type = event.value.type;

    if (type == "dropdown") {
      this.searchElement = "dropdown";
      this.searchColumnValue = event.value.value;
    } else if (type == "textbox") {
      this.searchElement = "textbox";
    } else if (type == "calendar") {
      this.searchElement = "calendar";
    }

  }



  onAddFilter(column) {
    console.log(column);
    this.searchFilter.push({ name: column.value.column, value: this.searchElementValue.value || this.searchElementValue, show: { label: column.label, value: this.searchElementValue.label || this.searchElementValue } });
    console.log(this.searchFilter);
    this.searchElementValue = "";
  }

  onDeleteFilter(index) {
    this.searchFilter.splice(index, 1);
  }

  applySearchFilter() {
    this.filterDialog = false;
    this.setDataInto.emit(this.searchFilter);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/utils/filter/filter.component.ts